import { GtpPushProvisionResult, RNToWebMessage } from '@eika-infrastruktur/mobilbank-lib';

import { NavigateFunction } from '@domain/app';
import { Card } from '@generated-types';
import { KortbetjeningText } from '@hooks/use-text';

import { PushProvisionWebAction, SigningWebAction } from './types';

export const handleEndGTPWalletProcess = (card: Card, navigate: NavigateFunction) => {
    setTimeout(() => {
        navigate('GOOGLE_WALLET')({ cid: card.id, ctype: card.type });
    }, 3000);
};

export const handleSigningState = (
    data: RNToWebMessage<SigningWebAction> | undefined,
    handlePermissionHasBeenSigned: () => void,
    setSigningError: (error: string) => void,
    text: KortbetjeningText,
) => {
    if (data === undefined) {
        return;
    }

    const {
        googleWalletConfirmAddPermissionToGooglePaySigningCancelledError,
        googleWalletConfirmAddPermissionToGooglePayError,
    } = text;

    switch (data.action) {
        case 'BROWSER_CALLBACK_RESULT': {
            switch (data.payload) {
                case 'SIGNED_NOT_USED': {
                    handlePermissionHasBeenSigned();
                    break;
                }

                case 'CANCEL': {
                    setSigningError(googleWalletConfirmAddPermissionToGooglePaySigningCancelledError);
                    break;
                }

                case 'CANCELLED': {
                    setSigningError(googleWalletConfirmAddPermissionToGooglePaySigningCancelledError);
                    break;
                }

                case 'ERROR': {
                    setSigningError(googleWalletConfirmAddPermissionToGooglePayError);
                    break;
                }

                default: {
                    setSigningError(googleWalletConfirmAddPermissionToGooglePayError);
                    break;
                }
            }

            break;
        }

        default:
            break;
    }
};

export const handlePushProvisionState = (
    data: RNToWebMessage<PushProvisionWebAction> | undefined,
    setPushProvisionError: (error: string | null) => void,
    handlePushProvisionSuccess: () => void,
    text: KortbetjeningText,
) => {
    if (typeof data === 'undefined') {
        return;
    }

    const { googleWalletPushProvisionError, googleWalletPushProvisionCancelled } = text;

    switch (data.action) {
        case 'GTP_PUSH_PROVISION_ERROR': {
            setPushProvisionError(googleWalletPushProvisionError);
            break;
        }

        case 'GTP_PUSH_PROVISION_RESULT': {
            const result = data.payload as GtpPushProvisionResult;

            if (result.success) {
                handlePushProvisionSuccess();
            } else {
                setPushProvisionError(googleWalletPushProvisionCancelled);
            }

            break;
        }

        default:
            break;
    }
};
